import "antd-mobile/es/global";
import { unstableSetRender } from "antd-mobile";
import { createRoot, type Root } from "react-dom/client";

const roots = new WeakMap<Element | DocumentFragment, Root>();

unstableSetRender((node, container) => {
  let root = roots.get(container);
  if (!root) {
    root = createRoot(container);
    roots.set(container, root);
  }
  root.render(node);
  return async () => {
    root?.unmount();
    roots.delete(container);
  };
});
